var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('router-link',{staticClass:"preview__button",attrs:{"to":"/home"}},[_vm._v("Олег Ардимасов")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }